import { render, staticRenderFns } from "./ModalChangeBrand.vue?vue&type=template&id=08af4284&scoped=true&"
import script from "./ModalChangeBrand.vue?vue&type=script&lang=js&"
export * from "./ModalChangeBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af4284",
  null
  
)

export default component.exports